import React, {Component} from "react";
import {Field, reduxForm} from "redux-form";
import SelectField from "material-ui/SelectField";
import MenuItem from "material-ui/MenuItem";
import AutoComplete from "material-ui/AutoComplete";
import axios from "axios";
import Checkbox from "material-ui/Checkbox";
import Button from "react-bootstrap/lib/Button";
import {DatePicker, TextField} from "redux-form-material-ui";

let startDate = new Date(new Date().getFullYear(), 0, 1);
let endDate = new Date();



class Form extends Component {
  constructor() {
    super();
    this.state = {error: "", empId:"0", employees : []};
    this.handleChange = this.handleChange.bind(this);
    this.changeEmpId = this.changeEmpId.bind(this);
  }

  handleChange(date) {
    this.setState({
      startDate: date
    });
  }

  changeEmpId(id) {
    this.setState({empId: id})
  }

  componentDidMount() {
    axios.get(process.env.REQ_URL + '/myTeamEmployee', {
      url: '',
      method: 'get',
      params: {},
      data: {},
      withCredentials: true,
      contentType: 'application/json',
      responseType: 'json',
    }).then((response)=> {
      this.setState({employees : response.data.data});
      console.log(employees);
    }).catch((error)=> {

    });
  }

  componentWillReceiveProps(props) {
    this.setState({empId: props.empId})
  }

  render() {
    const {handleSubmit, pristine, reset, submitting} = this.props;
    const formStyle = {
      padding: '0px'
    };

    return (
      <div style={{formStyle}}>
        <form onSubmit={handleSubmit(data => {
          if (data.startDate > data.endDate) {
            this.setState({error: "Check the Dates"});
            return;
          }
          else {
            let request = new Object();
            request.startDate = data.startDate ? data.startDate : startDate;
            request.endDate = data.endDate ? data.endDate : endDate;
            this.props.formSubmit(request);
          }
        })}>

        <div className = "col-md-12">
          <div className = "row">
            <div className="col-md-2">
              <img src="/public/images/calendar.png" style={{paddingRight: '10'}}/>
              <Field name="startDate"
                   container="inline"
                   autoOk={true}
                   component={DatePicker}
                   style={{display: 'inline'}}
                   defaultValue={startDate}
                   value = {startDate}
                   mode={'portrait'}
                   textFieldStyle={{width: '70%'}}
                   floatingLabelText="Start Date"
                   hintText="Start Date "/>
            </div>
            <div className="col-md-2" style={{paddingRight: 0}}>
              <img src="/public/images/calendarO.png" style={{paddingRight: '10'}}/>
              <Field name="endDate"
                   autoOk={true}
                   container="inline"
                   style={{display: 'inline'}}
                   component={DatePicker}
                   defaultValue={endDate}
                   floatingLabelText="End Date"
                   textFieldStyle={{width: '70%'}}
                   value = {endDate}
                   mode={'portrait'}
                   hintText="End Date "/>
            </div>
            <div className="col-md-3">
              <SelectField
                labelStyle={{ color: "#1E88E5" }}
                style={{ width: "90%", fontSize: "12px", marginTop: "23px"}}
                id = "employee"
                value={this.state.empId}
                onChange={(option, data, employee) => {
                  this.props.changeEmp(employee);
                }}
              >
              <MenuItem value="0" primaryText="Select Employee" />
              {
                this.state.employees.map((employee, index) => {
                  return (
                    <MenuItem value={employee.empId} primaryText={employee.empName}/>
                  );
                })
              }
              </SelectField>
            </div>
          </div>
          <div className = "row" style={{display: 'inline'}}>
            <div className="col-md-1" style={{paddingLeft: 0}}>
              <Checkbox
                style={{paddingLeft: '0px', paddingTop: '40px', height: '30px', paddingBottom: 0, width: '40px'}}
                inputStyle={{height: '30px'}}
                iconStyle={{fill: '#5cb85c'}}
                labelStyle={{fontSize: '15px'}}
                checked={this.props.indirect}
                label="Indirect"
                onCheck={()=> {
                  this.props.changeDirect();
                }}/>
            </div>
            {(this.props.isVertical) ?

            <div className="col-md-1" style={{paddingLeft: 0}}>
                     <Checkbox
                        style={{paddingLeft: '0px', paddingTop: '40px', height: '30px', paddingBottom: 0, width: '40px'}}
                        inputStyle={{height: '30px'}}
                        iconStyle={{fill: '#5cb85c'}}
                        labelStyle={{fontSize: '15px'}}
                        checked={this.props.vertical}
                        label="Vertical"
                        onCheck={()=> {
                          this.props.changeView();
                        }}/>
            </div> : null}
          </div>
          <div className = "col-md-2" style={{'paddingTop': '14px'}}>
            <div style={{'textAlign': 'left', 'display': 'inline', 'padding': 0, 'marginLeft': '0'}}>
              <div className = "col-md-2" style={{'margin': '2% 0px 0% 0px', 'paddingLeft': '0'}}>
                <div>
                  <Button
                       backgroundColor="#008bcf"
                       className="btn btn-default btn-lg"
                       style={{width: '100px', marginLeft: '5px'}}
                       onClick={()=> {
                       handleSubmit((data)=> {
                         console.log("am i doing it right?");
                         console.log(data);
                       })
                       }}
                       type="submit"
                       disabled={false}> Search
                       <img src="/public/images/magnifying-glass.png"
                           style={{'paddingLeft': '6px'}}
                       />
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
        </form>
      </div>
    )
  }
}

export default reduxForm({
  form: 'ReportSearch',

})(Form)






/** WEBPACK FOOTER **
 ** ./src/feature/attendance/TeamAttendance/ReportSearch.js
 **/